/* eslint-disable react/jsx-props-no-spreading */
import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Autocomplete,
  TextField,
  Box,
  Typography,
} from "@mui/material";
import { TemplateInformation } from "../../services/cleaning-data-service";

interface CleanseDialogProps {
  open: boolean;
  templates: TemplateInformation[] | undefined;
  onClose: () => void;
  onConfirm: (templateId: number) => void;
  isLoading?: boolean;
}

const CleanseDialog: React.FC<CleanseDialogProps> = ({
  open,
  templates,
  onClose,
  onConfirm,
  isLoading = false,
}) => {
  const [selectedTemplate, setSelectedTemplate] =
    useState<TemplateInformation | null>(null);

  const handleConfirm = () => {
    if (selectedTemplate) {
      onConfirm(selectedTemplate.id);
      setSelectedTemplate(null);
    }
  };

  const handleClose = () => {
    setSelectedTemplate(null);
    onClose();
  };

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
      <DialogTitle>Select Template to Cleanse Field</DialogTitle>
      <DialogContent>
        <Box sx={{ pt: 1 }}>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
            Choose a template to apply cleansing rules to this field.
          </Typography>
          <Autocomplete
            options={templates || []}
            getOptionLabel={(option) => option.description}
            value={selectedTemplate}
            onChange={(event, newValue) => setSelectedTemplate(newValue)}
            size="small"
            disabled={isLoading || !templates}
            renderInput={(params) => (
              <TextField
                {...params}
                placeholder="Select a template"
                label="Template"
              />
            )}
            sx={{
              "& .MuiOutlinedInput-root": {
                "& fieldset": {
                  borderColor: "grey.400",
                },
                "&:hover fieldset": {
                  borderColor: "primary.main",
                },
                "&.Mui-focused fieldset": {
                  borderColor: "primary.main",
                },
              },
            }}
          />
        </Box>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button onClick={handleClose} disabled={isLoading}>
          Cancel
        </Button>
        <Button
          onClick={handleConfirm}
          variant="contained"
          disabled={!selectedTemplate || isLoading}
        >
          Cleanse
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CleanseDialog;
